import React, {Component} from 'react';

export default class BarLabel extends Component {
    constructor(props){
        super(props);
    }

    componentDidMount(){
        const {name, x, y, setTooltipPosition} = this.props;
        const xCoord = x - 250;
        const yCoord = y + 495;

        return name === 'Brand Ambassadors' ? setTooltipPosition(xCoord, yCoord) : null;
    }

    componentWillUpdate(nextProps){
        const {name, x, y, setTooltipPosition} = nextProps;
        const xCoord = x - 250;
        const yCoord = y + 495;

        return name === 'Brand Ambassadors' ? setTooltipPosition(xCoord, yCoord) : null;
    }

    render(){
        const {name, value, x, y, width, textAnchor, height, fontSize, index, setTooltipPosition} = this.props;
        const priceReference = ['$$$$$', '$$$', '$'];
        const xCoord = x;
        const yCoord = y - 5;
        const percentage = `${value}%`;

        return(
            <text
                key={index}
                textAnchor={textAnchor}>
                <tspan
                    className='bar-label-name'
                    x={xCoord}
                    y={yCoord}
                    fill='#808080'>
                    {name}
                </tspan>
                <tspan
                    className='bar-label-percentage'
                    x={xCoord}
                    y={yCoord + 50}
                    fill='white'>
                    {percentage}
                </tspan>
                <tspan
                    className='engagement-rate-tspan'
                    x={xCoord}
                    y={yCoord + 62}
                    fill='white'>
                    engagement rate
                </tspan>
                <tspan
                    className='dollar-sign-tspan'
                    x={xCoord}
                    y={yCoord + 95}
                    fill='white'>
                    {priceReference[index]}
                </tspan>
            </text>
        );
    }
}



// WEBPACK FOOTER //
// ./web/js/components/brand_ambassadors/engagement_rate_graph/bar_label.js